import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react'
import Image from 'next/image';

const SkaiciuoklesTurinys = () => {
    const [aggregateRating, setAggregateRating] = useState({
        ratingValue: 4.8,
        ratingCount: 39978,
        rated: false,
        rating: 0,
    });

    return (
        <Grid container direction="row" spacing={4}>
            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
                <br />
                <Typography variant="body2">
                    <span>
                        Atlyginimo skaičiuoklė suderinta su teisės aktų pakeitimais, įsigaliojusiais nuo{" "}
                    </span>
                    <span>2026 m. sausio 1 d.</span>
                </Typography>
                <Typography variant="body2">
                    <span>
                        Skaičiuoklę patikrino <Link href="https://tezaurus.lt/audito-paslaugos" target="_blank" rel="noopener">audito paslaugas</Link> teikianti įmonė UAB &quot;Tezaurus auditas&quot;.
                        <Image src="/logo.jpg" alt="Tezaurus auditas logo" width={80} height={24} />
                    </span>
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <Box sx={{ mt: 3 }}>
                    <Rating
                        name="rating"
                        value={aggregateRating.rating}
                        onChange={(_event, newRating: any) => {
                            setAggregateRating({
                                ratingValue: aggregateRating.ratingValue,
                                ratingCount: aggregateRating.rated
                                    ? aggregateRating.ratingCount
                                    : aggregateRating.ratingCount + 1,
                                rated: true,
                                rating: newRating,
                            });
                            // if (!aggregateRating.rated) {
                            //     ReactGA.event({
                            //         category: "Rating",
                            //         action: "salary_calculator",
                            //         value: newRating,
                            //     });
                            // }
                        }}
                    />
                    <Typography
                        itemProp="aggregateRating"
                        itemScope
                        itemType="https://schema.org/AggregateRating"
                        variant="caption"
                    >
                        <span itemProp="ratingValue">
                            {aggregateRating.ratingValue}
                        </span>{" "}
                        (
                        <span itemProp="ratingCount">
                            {aggregateRating.ratingCount}
                        </span>{" "}
                        įvertinimai)
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    )
}

export default SkaiciuoklesTurinys